import React, { useState } from "react";
import "./Timeline.css";
import { timelineData } from "../../data/content";
import timelineImg from "../../assets/images/sec3.png";

const Timeline = () => {
  const [showTimeline, setShowTimeline] = useState(false);

  return (
    <section
      id="timeline"
      className={`timeline ${showTimeline ? "show" : ""}`}
      onMouseEnter={() => setShowTimeline(true)}
    >
      <div className="timeline-content">
        <h2 className="timeline-title">Key Achievements</h2>

        <div className="timeline-list">
          {timelineData.map((item, index) => (
            <div
              className="timeline-item"
              key={index}
              style={{ transitionDelay: `${index * 0.25}s` }}
            >
              <span className="timeline-year">{item.year}</span>
              <span className="timeline-text">{item.text}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="timeline-image-wrapper">
        <img src={timelineImg} alt="Fairuz singing" className="timeline-image" />
      </div>
    </section>
  );
};

export default Timeline;